export default {"src":"/_next/static/media/PeopleDataLabs.d33464a5.svg","height":80,"width":80};